<div class="page-title-area page-title-area-two title-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-text">
                <h2>Contact Us</h2>

                <ul>
                    <li><a [routerLink]="homeUrl">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>Contact Us</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="contact-form contact-form-four pb-100">
    <div class="loaction-area">
        <div class="container">
            <div class="row location-bg">
                <div class="col-sm-6 col-lg-4">
                    <div class="location-item">
                        <div class="location-icon">
                            <i class="flaticon-pin"></i>
                        </div>
                        <h3>Location</h3>
                        <ul>
                            <li><b>Head Office: </b>Office No 03, LG Sami Plaza, Opposite Lahore High Court, Rawalpindi Bench, Rawalpindi</li>
                        </ul>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="location-item">
                        <div class="location-icon">
                            <i class="flaticon-call"></i>
                        </div>

                        <h3>Phone</h3>

                        <ul>
                            <li><a href="tel:+923100022272">UAN: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; 009 231 000 222 72</a></li>
                            <li><a href="https://wa.me/00923100022272">WhatsApp: &nbsp; 009 231 000 222 72</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
                    <div class="location-item">
                        <div class="location-icon">
                            <i class="flaticon-email"></i>
                        </div>
                        
                        <h3>Email</h3>

                        <ul>
                            <li><a href="mailto:admin@walayetlaw.com">admin@walayetlaw.com</a></li>
                            <li><a href="mailto:saqib@walayetlaw.com">saqib@walayetlaw.com</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <h5>National & International Collaboration</h5>
        <p>
            Over the past few years, we have worked closely with law firms from Local and International jurisdictions, and in doing
            so close nexus has been developed with Locally based Law Firm, <b>"Paracha & Paracha (LLP), Islamabad"</b> & <b>
                "Mian Abdul Rauf Law Associates, Islamabad"</b>, and a United Arab Emirates-based international law form <b>
                    "Al-Meezan Debt Collection"</b>. We are currently working with the above Law Firms on serveral projects in 
                    Pakistan and UAE. They have offices in almost all the major cities of the gulf. Below are our <b>Liaison Offices </b>:
        </p>
        <ol>
            <li><b>Islamabad: </b> Office No.109A-B, Evacuee Trust Complex, Adjacent to Marriott Hotel</li>
            <li><b>Lahore: </b> 4-Birdwood Road, Off Jail Road</li>
            <li><b>UAE: </b>Office No. 1702, 17th floor Sail Towers Corniche Road, Abu Dhabi</li>
            <li><b>Canada: </b>75 International Blvd Suite 204, Toronto, Ontario</li>
        </ol>
    </div>
    <br /><br />

    <div class="container-fluid">
        <app-contact-form></app-contact-form>
    </div>
</div>

<div class="map-area">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3325.0082806331698!2d73.09928541484503!3d33.55316118074467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfed4c8104d281%3A0xaaf6ad14b2f21a22!2sWALAYET%20%26%20ASSOCIATES%20LLP!5e0!3m2!1sen!2s!4v1648744668314!5m2!1sen!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>